import { render } from "./StudentFlightPracticeView.vue?vue&type=template&id=6ec72a04&scoped=true"
import script from "./StudentFlightPracticeView.vue?vue&type=script&lang=js"
export * from "./StudentFlightPracticeView.vue?vue&type=script&lang=js"

import "./StudentFlightPracticeView.vue?vue&type=style&index=0&id=6ec72a04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec72a04"]])

export default __exports__